import React, { useEffect, useRef } from 'react'

import { t } from 'src/translations'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

import ChatBubble from './ChatBubble'
import * as VoiceAI from './VoiceAI.types'
import { useChatHistory } from './useChatHistory'
import { useVoiceAI } from './useVoiceAI'

const ConvoOrdering: React.FC = () => {
  const { ooRestaurant } = useRestaurant()
  const { isConnected, lastJsonMessage, sendText } = useVoiceAI(
    ooRestaurant!!.guid
  )
  const chatHistory = useChatHistory()
  const inputRef = useRef<HTMLInputElement>(null)
  const messagesRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.event === 'text') {
      chatHistory.addServerMessage(lastJsonMessage as VoiceAI.TextMessage)
    }
    // chatHistory is stable
  }, [lastJsonMessage]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.scrollTo({
        top: messagesRef.current.scrollHeight,
        behavior: 'smooth'
      })
    }
  }, [chatHistory.messages.length])

  return (
    <div id='convoOrdering-control' className='convoOrdering'>
      <div className='body'>
        <div className='paddedContent' ref={messagesRef}>
          <div>{t('convo-ordering.content-placeholder')}</div>
          <pre>{JSON.stringify({ isConnected, lastJsonMessage }, null, 2)}</pre>
          {chatHistory.messages.map((message, index) => (
            <ChatBubble key={index} message={message} />
          ))}
        </div>
      </div>
      <div className='footer'>
        <form
          action='#'
          autoComplete='off'
          onSubmit={(e) => {
            e.preventDefault()

            const message = inputRef.current?.value

            if (message) {
              chatHistory.addClientMessage({
                event: 'text',
                text: { content: message }
              } as VoiceAI.TextMessage)

              sendText(message)

              inputRef.current.value = ''
            }
          }}
        >
          <input
            ref={inputRef}
            type='text'
            name='message'
            placeholder={t('convo-ordering.message-placeholder')}
          />
          <button type='submit'>{t('convo-ordering.send')}</button>
        </form>
      </div>
    </div>
  )
}

export default ConvoOrdering
